import { render, staticRenderFns } from "./healthreport.vue?vue&type=template&id=aee195fc&scoped=true&"
import script from "./healthreport.vue?vue&type=script&lang=js&"
export * from "./healthreport.vue?vue&type=script&lang=js&"
import style0 from "./healthreport.vue?vue&type=style&index=0&id=aee195fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee195fc",
  null
  
)

export default component.exports